var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.messageData)?_c('div',{staticClass:"max-w-[300px]"},[_c('div',{staticClass:"details-wrapper"},[_vm._v(" "+_vm._s(_vm.messageData?.text)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }